import React from "react";

function DocusignForm({ form, addToDocusignList }) {
  return (
    <div
      className="ps-4 text-primary mb-2 d-flex"
      role="button"
      onClick={() => {
        addToDocusignList(form);
      }}
    >
      <div className="bg-warning rounded text-dark px-1 me-1 fw-bold">DS</div>
      {form.FormDescription}
    </div>
  );
}

export default DocusignForm;
